import type { TagType } from './types'

export const tagTypes: TagType[] = [
  'gainsboro',
  'pink-lace',
  'pale-lavender',
  'lavender',
  'water',
  'green-cyan',
  'papaya-whip',
  'lumber',
  'light-red',
  'white',
]

export let tagTypesMap: Record<TagType, TagType> = {} as Record<
  TagType,
  TagType
>

export const variants = ['readonly', 'selectable']

for (const type of tagTypes) {
  tagTypesMap = { ...tagTypesMap, [type]: type }
}

export default { tagTypes, tagTypesMap }
